import { render } from "./svg-star.vue?vue&type=template&id=2e3b989a"
import script from "./svg-star.vue?vue&type=script&lang=ts"
export * from "./svg-star.vue?vue&type=script&lang=ts"
script.render = render

export default script